import React from 'react'

// One choice out of a few, made by clicking a tile - its title, and a line
// saying what it means. Radio buttons underneath, so it still behaves as one
// group, from the keyboard too.
const ChoiceTiles = ({ name, value, options, onChange, disabled }) => (
  <div className="choice-tiles">
    <For each="option" of={options}>
      <label
        key={option.value}
        className={`choice-tile ${value === option.value ? 'is-selected' : ''} ${
          disabled ? 'is-disabled' : ''
        }`}
      >
        <span className="choice-tile__head">
          <input
            type="radio"
            name={name}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            disabled={disabled}
          />
          <span className="choice-tile__title">{option.label}</span>
        </span>
        <If condition={option.hint}>
          <span className="choice-tile__hint">{option.hint}</span>
        </If>
      </label>
    </For>
  </div>
)

export default ChoiceTiles
